import { DatePicker } from '@shared/ui/kit';
import type { DatePickerInputStatus } from '@shared/ui/kit/date-picker/model/types';
import { LockedDateField } from '@shared/ui/locked-date-field';
import styles from './invitation-date-field.module.scss';

interface InvitationDateFieldProps {
  invitationExpiresAt: Date | null;
  warnings: string[];
  invitationDateReadOnly?: boolean;
  invitationDatePickerStatus?: DatePickerInputStatus;
  invitationDatePickerInputMessage?: string;
  onInvitationDateChange: (dates: [Date | null, Date | null]) => void;
  onInvitationCalendarVisibilityChange?: (open: boolean) => void;
}

export const InvitationDateField = ({
  invitationExpiresAt,
  warnings,
  invitationDateReadOnly = false,
  invitationDatePickerStatus = 'default',
  invitationDatePickerInputMessage,
  onInvitationDateChange,
  onInvitationCalendarVisibilityChange,
}: InvitationDateFieldProps) => {
  const hasRepeatingWarnings = warnings.length > 0;

  return (
    <div className={styles.dateFieldBlock}>
      {invitationDateReadOnly ? (
        <div className={styles.dateWrapperLocked}>
          <LockedDateField label="Срок действия" date={invitationExpiresAt} />
        </div>
      ) : (
        <DatePicker
          labelText="Срок действия"
          size="small"
          isRange={false}
          selectedDate={invitationExpiresAt}
          setNewSelectedDate={onInvitationDateChange}
          inputStatus={invitationDatePickerStatus}
          inputMessage={invitationDatePickerInputMessage ?? undefined}
          onCalendarVisibilityChange={onInvitationCalendarVisibilityChange}
        />
      )}
      {hasRepeatingWarnings && !invitationDatePickerInputMessage && (
        <div className={styles.warningList}>
          {warnings.map((warning) => (
            <p key={warning} className={styles.warningText}>
              {warning}
            </p>
          ))}
        </div>
      )}
    </div>
  );
};
